import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { useUserSetupStore } from '@sib/auth';
import { Calendar, Home } from '@sib/ui/icons';
import {
  Account,
  Billing,
  Chart,
  Chat,
  Documents,
  Info,
  TeamOrg,
  Savings,
  Feedback,
  LocationList,
  Vendors,
  YourTickets,
  QuestionMark,
  BillPay,
  ContractTerms,
} from '@sib/ui/icons';
import { paths } from '@spendbrain/config/paths';
import { useSpendbrainRoutesAccess } from '@spendbrain/hooks';
import { useFeedbackStore } from '../../stores';

export const useSidebarItems = () => {
  const { t } = useTranslation();
  const { openFeedbackDialog } = useFeedbackStore();
  const {
    organization: { id: organizationId },
    isSibEmployee,
  } = useUserSetupStore();

  const ticketsPath = isSibEmployee
    ? generatePath(paths.tickets.employee.root, { orgId: organizationId })
    : paths.tickets.client.root;

  const { isRouteAvailable } = useSpendbrainRoutesAccess();

  return [
    {
      href: paths.subsidiaryOrganization,
      title: t('sidebar.subsidiaryOrganization'),
      icon: TeamOrg,
    },
    {
      href: paths.dashboard,
      title: t('sidebar.dashboard'),
      icon: Home,
    },
    {
      href: paths.savings,
      title: t('sidebar.savingsAndSpendAnalysis'),
      icon: Savings,
    },
    {
      href: paths.services,
      title: t('sidebar.services'),
      icon: Chart,
    },
    {
      href: paths.documents.root,
      title: t('sidebar.documents'),
      icon: Documents,
    },
    {
      href: paths.locations,
      title: t('sidebar.locations'),
      icon: LocationList,
    },
    { href: paths.reports, title: t('sidebar.reports'), icon: Chart },
    {
      href: ticketsPath,
      title: t('sidebar.tickets'),
      icon: YourTickets,
    },
    {
      href: paths.upcomingEvents,
      title: t('sidebar.upcomingEvents'),
      icon: Calendar,
    },
    {
      href: paths.chat,
      title: t('sidebar.chat'),
      icon: Chat,
    },
    {
      href: paths.yourTeam,
      title: t('sidebar.yourTeam'),
      icon: TeamOrg,
    },
    {
      href: paths.account,
      title: t('sidebar.account'),
      icon: Account,
    },
    {
      href: paths.billing,
      title: t('sidebar.billings'),
      icon: Billing,
    },

    {
      href: paths.vendors,
      title: t('sidebar.vendors'),
      icon: Vendors,
    },
    {
      href: paths.billPay,
      title: t('sidebar.billPay'),
      icon: BillPay,
    },
    {
      href: paths.contractTerms,
      title: t('sidebar.contractTerms'),
      icon: ContractTerms,
    },
    {
      href: paths.help,
      title: t('sidebar.help'),
      icon: QuestionMark,
    },
    {
      href: 'https://aboutsib.com/',
      title: t('sidebar.about'),
      icon: Info,
    },
    {
      title: t('sidebar.sendFeedback'),
      icon: Feedback,
      onClick: openFeedbackDialog,
    },
  ].filter(({ href }) => !href || isRouteAvailable(href));
};
